import styled, { css } from "styled-components";
import theme from "styled-theming";
import colors from "../styles/colors";
import { ThemeType } from "../styles/theme";

const StatusBallOnlineColor = theme("mode", {
    [ThemeType.light]: colors.greenPrimary,
    [ThemeType.dark]: colors.greenPrimary,
});

const StatusBallOfflineColor = theme("mode", {
    [ThemeType.light]: colors.grey_2,
    [ThemeType.dark]: colors.grey_2,
});

const StatusBall = css`
    width: 12px;
    height: 12px;
    display: inline-block;
    border-radius: 12px;
    vertical-align: middle;
    margin-left: 10px;
    margin-bottom: 2px;
`

export const StatusBallOnline = styled.i`
    ${StatusBall}
    background: ${StatusBallOnlineColor};
`

export const StatusBallOffline = styled.i`
    ${StatusBall}
    background: ${StatusBallOfflineColor};
`